//Style
import '../../styles/main/modal.scss'
import '../../styles/main/collapsible.scss'

//Component
import Collapsible from './collapsible'
import ImageViewer from './imageviewer'

//Image
import GoToProject from '../../assets/go_to_project.svg'
import ProjectImg1 from '../../assets/project_img_1.jpg'
import ProjectImg2 from '../../assets/project_img_2.jpg'
import ProjectImg3 from '../../assets/project_img_3.jpg'

//Basics 
import { useState, useEffect } from 'react'

// Language
import { useLanguage } from '../../context/language_context'


function Modal({
    closeModal,
    creationdate,
    name,
    description,
    objectives,
    langages,
    github,
    projectstate,
    images = []
}) {

    const { language } = useLanguage()

    const [isGalleryOpen, setIsGalleryOpen] = useState(false)
    const [isDragging, setIsDragging] = useState(false)
    const [offsetX, setOffsetX] = useState(0)
    const [offsetY, setOffsetY] = useState(0)

    const [modalPosition, setModalPosition] = useState(() => {

        if (window.innerWidth > 768) {

            return {
                x: (window.innerWidth - 550) / 2,
                y: (window.innerHeight - 500) / 2,
            }

        } else {

            return {
                x: (window.innerWidth - 350) / 2,
                y: (window.innerHeight - 500) / 2,
            }

        }

    })


    useEffect(() => {

        if (isDragging) {

            const onMouseMove = (e) => {
                const newX = e.clientX - offsetX
                const newY = e.clientY - offsetY

                setModalPosition({
                    x: newX,
                    y: newY
                })
            }


            const onMouseUp = () => {
                setIsDragging(false)
            }


            const onTouchMove = (e) => {

                if (isDragging && e.touches.length === 1) {

                    const newX = e.touches[0].clientX - offsetX
                    const newY = e.touches[0].clientY - offsetY

                    setModalPosition({
                        x: newX,
                        y: newY
                    })

                }

            }


            const onTouchEnd = () => {

                if (isDragging) {
                    setIsDragging(false)
                }

            }


            window.addEventListener('mousemove', onMouseMove)
            window.addEventListener('mouseup', onMouseUp)
            window.addEventListener('touchmove', onTouchMove)
            window.addEventListener('touchend', onTouchEnd)


            return () => {

                window.removeEventListener('mousemove', onMouseMove)
                window.removeEventListener('mouseup', onMouseUp)
                window.removeEventListener('touchmove', onTouchMove)
                window.removeEventListener('touchend', onTouchEnd)

            }

        }

    }, [isDragging, offsetX, offsetY])


    const handleMouseDown = (e) => {

        setIsDragging(true)

        setOffsetX(
            e.clientX - modalPosition.x
        )

        setOffsetY(
            e.clientY - modalPosition.y
        )

    }


    const handleTouchStart = (e) => {

        if (e.touches.length === 1) {

            e.preventDefault()

            setIsDragging(true)

            setOffsetX(
                e.touches[0].clientX - modalPosition.x
            )

            setOffsetY(
                e.touches[0].clientY - modalPosition.y
            )

        }

    }


    return (

        <div className="modal_overlay">

            <div
                className="modal"
                style={{
                    top: modalPosition.y,
                    left: modalPosition.x
                }}
            >

                {/* HEADER */}

                <div className='modal_title'>

                    <div
                        className='modal_title_up'
                        onMouseDown={handleMouseDown}
                        onTouchStart={handleTouchStart}
                    >

                        <h3>
                            C:/Maurine_Duet/{name}
                        </h3>

                        <p
                            className='close_button'
                            onClick={closeModal}
                        >
                            X
                        </p>

                    </div>


                    <nav>

                        <ul>
                            <li>File</li>
                            <li>Edit</li>
                            <li>View</li>
                            <li>Help</li>
                        </ul>

                    </nav>

                </div>


                {/* CONTENT */}

                <div className='modal_main'>


                    {/* PROJECT LINK */}

                    {github && (

                        <a
                            className='go_to_project'
                            href={github}
                            target="_blank"
                            rel="noreferrer"
                        >

                            <img
                                src={GoToProject}
                                alt={
                                    language === 'fr'
                                        ? "Icône aller au projet"
                                        : "Open project icon"
                                }
                            />

                            {language === 'fr'
                                ? 'Accéder au projet'
                                : 'View project'}

                        </a>

                    )}


                    <div className='project_details'>


                        {/* DESCRIPTION */}

                        {description && (

                            <Collapsible
                                label={
                                    language === 'fr'
                                        ? 'Description du projet'
                                        : 'Project description'
                                }
                            >

                                <img
                                    src={ProjectImg1}
                                    alt="Meme de chat"
                                />

                                <p className='collapsible_text'>
                                    {description}
                                </p>

                            </Collapsible>

                        )}


                        {/* OBJECTIVES */}

                        {objectives && (

                            <Collapsible
                                label={
                                    language === 'fr'
                                        ? 'Objectifs du projet'
                                        : 'Project objectives'
                                }
                            >

                                <p className='collapsible_text'>
                                    {objectives}
                                </p>

                                <img
                                    src={ProjectImg2}
                                    alt="Petit astronaute"
                                />

                            </Collapsible>

                        )}


                        {/* PROJECT STATE */}

                        {projectstate && (

                            <Collapsible
                                label={
                                    language === 'fr'
                                        ? 'État du projet'
                                        : 'Project status'
                                }
                            >

                                <p className='collapsible_text'>
                                    {projectstate}
                                </p>

                                <img
                                    src={ProjectImg2}
                                    alt="Petit astronaute"
                                />

                            </Collapsible>

                        )}


                        {/* LANGUAGES */}

                        {langages && (

                            <Collapsible
                                label={
                                    language === 'fr'
                                        ? 'Langages'
                                        : 'Languages'
                                }
                            >

                                <img
                                    src={ProjectImg3}
                                    alt="Petit personnage"
                                />

                                <p className='collapsible_text'>
                                    {langages}
                                </p>

                            </Collapsible>

                        )}


                        {/* GALLERY */}

                        {images.length > 0 && (

                            <button
                                className="open_gallery"
                                onClick={() =>
                                    setIsGalleryOpen(true)
                                }
                            >

                                {language === 'fr'
                                    ? 'Galerie'
                                    : 'Gallery'}

                            </button>

                        )}

                    </div>

                </div>


                {/* IMAGE VIEWER */}

                {isGalleryOpen && (

                    <ImageViewer
                        images={images}
                        projectName={name}
                        closeViewer={() =>
                            setIsGalleryOpen(false)
                        }
                    />

                )}


                {/* FOOTER */}

                {creationdate && (

                    <div className='modal_footer'>

                        <p>
                            {language === 'fr'
                                ? 'Date de création : '
                                : 'Creation date: '}

                            {creationdate}
                        </p>

                    </div>

                )}

            </div>

        </div>

    )
}


export default Modal